import TrustedCertified from '@/components/common/TrustedCertified';
import WhyChooseUS from '@/components/common/WhyChooseUs';
import AboutCompany from '@/components/home/AboutCompany';
import CompanyTrust from '@/components/home/CompanyTrust';
import GetFreeTrial from '@/components/home/FreeTrial';
import HomeHero from '@/components/home/hero';
import { News } from '@/components/home/News';
import ProjectBuild from '@/components/home/Projectbuild';
import { Services } from './Services';
const Home = () => {
  return (
    <div className="home mt-[10rem] w-full">
      <HomeHero />
      <CompanyTrust />
      <TrustedCertified />
      <AboutCompany />
      <WhyChooseUS />
      <ProjectBuild />
      <Services isHome={true} />
      <GetFreeTrial />
      <News />
    </div>
  );
};

export default Home;
